{
  "Approve": "Approuver",
  "DeleteReminder": "Supprimer le rappel",
  "DismissAlert": "Ignorer",
  "DismissReminder": "Rejeter le rappel",
  "Earlier": "PLUS TÔT",
  "EditReminder": "Modifier le rappel",
  "High": "Élevé",
  "MarkAllAsRead": "Tout marquer comme lu",
  "Reject": "Rejeter",
  "RemindMe15Min": "Me le rappeler dans 15 minutes",
  "RemindMe5Min": "Me le rappeler dans 5 minutes",
  "RemindMe60Min": "Me le rappeler dans une heure",
  "RemindMeTomorrow": "Me le rappeler demain",
  "Snooze": "Me le rappeler",
  "markAsRead": "Marquer comme lu",
  "markAsUnread": "Marquer comme non lu",
  "noNotifications": "Vous recevrez des informations importantes sur nos produits, votre collaboration avec d’autres utilisateurs et d’autres mises à jour pertinentes",
  "noNotificationsTitle": "Vos notifications apparaîtront ici"
}
